(function () {
    "use strict";

    angular
        .module("app")
        .component("childAccounts", { // child-accounts
            templateUrl: "src/app/account/childAccounts/childAccounts.html",
            controller: controller
        });

    function controller($http, session, toast) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.users = [];

        $ctrl.$onInit = () => {
            loadUsers();
        };

        $ctrl.toggleRoleClicked = (userId, roleName, value) => {
            const request = {
                user_id: userId,
                customer_id: $ctrl.session.customer.customer_id,
                role_name: roleName
            };
            if (value) {
                $http
                    .post("/api/users/create-user-role", request)
                    .then(() => toggleSessionRole(request, true))
                    .catch(toast.errorHandler);
            } else {
                $http
                    .post("/api/users/delete-user-role", request)
                    .then(() => toggleSessionRole(request, false))
                    .catch(toast.errorHandler);
            }
        };

        function toggleSessionRole(request, value) {
            if (request.user_id !== session.user.user_id)
                return;

            switch (request.role_name) {
                case "Reporting":
                    session.customer.is_reporting = value;
                    break;
                case "Ordering":
                    session.customer.is_ordering = value;
                    break;
                case "CS":
                    session.customer.is_cs = value;
                    break;
            }
        }

        $ctrl.toggleDisabledClicked = (userId, value) => {
            const request = {
                user_id: userId,
                customer_id: $ctrl.session.customer.customer_id,
                is_active: !value
            };
            $http
                .post("/api/users/toggle-active", request)
                .catch(toast.errorHandler);
        };

        $ctrl.sendEmailClicked = user => {
            const request = {
                user_id: user.user_id
            };
            $http
                .post("/api/users/password-reset", request)
                .then(result => {
                    toast.success("Send Email", `Email sent to ${user.email}.`);
                })
                .catch(toast.errorHandler);
        };

        $ctrl.deleteClicked = user => {
            const request = {
                user_id: user.user_id,
                customer_id: $ctrl.session.customer.customer_id
            };
            $http
                .post("/api/users/delete-user-customer", request)
                .then(() => {
                    $ctrl.users.splice($ctrl.users.findIndex(u => u.user_id === user.user_id), 1);
                    toast.success("Delete User", `${user.first_name} ${user.last_name} deleted.`);
                })
                .catch(toast.errorHandler);
        };

        $ctrl.userAdded = userId => {
            loadUsers();
        };

        function loadUsers() {
            return $http
                .get(`/api/users/for-customer/${session.customer.customer_id}`)
                .then(result => {
                    $ctrl.users = result.data;

                    $ctrl.users.forEach(u => {
                        if (u.user_id === session.user.user_id) {
                            u.canChangeAdmin = false;
                            u.canChangeDisabled = false;
                            u.canDelete = false;
                        } else {
                            u.canChangeAdmin = true;
                            u.canChangeDisabled = true;
                            u.canDelete = true;
                        }
                    });
                })
                .catch(toast.errorHandler);
        }
    }
    controller.$inject = ["$http", "sessionService", "stToastFactory"];

})()